import { FileField, Stack, TextField, useToast } from '@workramp/ui';
import { I18n } from '~/common/explicit-exports';
import { CMS_SUPPORTED_FILE_EXTENSIONS, MAX_FILE_SIZE, MAX_FILE_SIZE_TEXT } from '../../constants';
import { downloadFile } from '../../utils';
import { CMSAssetWarning } from './CMSAssetWarning';

interface CMSNewFileAssetModalTabProps {
  isUploading: boolean;
  fileValue: File;
  setFileValue: (file: File) => void;
  warningMessage: string;
  setWarningMessage: (message: string) => void;
}

export const CMSNewFileAssetModalTab = ({
  isUploading,
  fileValue,
  setFileValue,
  setWarningMessage,
  warningMessage,
}: CMSNewFileAssetModalTabProps) => {
  const TRANSLATED_FILE = I18n.t('js.admin.cms.file');
  const TRANSLATED_UPLOAD = I18n.t('js.admin.cms.upload');
  const FILE_SIZE_WARNING = I18n.t('js.admin.cms.file_size_limit', { size: MAX_FILE_SIZE_TEXT });
  const FILE_TYPE_WARNING = I18n.t('js.admin.cms.file_type_warning');
  const TRANSLATED_DOWNLOADING = I18n.t('js.admin.cms.downloading');

  const { open: openToast } = useToast();

  return (
    <Stack size={2}>
      {isUploading ? (
        <TextField isDisabled label={null} value={fileValue.name} />
      ) : (
        <FileField
          buttonLabel={TRANSLATED_UPLOAD}
          label={TRANSLATED_FILE}
          accept={CMS_SUPPORTED_FILE_EXTENSIONS.map((ext) => `.${ext}`).join(',')}
          onChange={(file) => {
            if (file.size > MAX_FILE_SIZE) {
              setWarningMessage(FILE_SIZE_WARNING);
              return;
            }
            if (!CMS_SUPPORTED_FILE_EXTENSIONS.includes(file.name.split('.').pop().toLowerCase())) {
              setWarningMessage(FILE_TYPE_WARNING);
              return;
            }
            setWarningMessage('');
            setFileValue(file);
          }}
          onRemove={() => {
            setWarningMessage('');
            setFileValue(null);
          }}
          onClickUploadedFile={() => {
            openToast({ children: TRANSLATED_DOWNLOADING });
            const localFileURL = URL.createObjectURL(fileValue);
            downloadFile(localFileURL, fileValue.name);
            URL.revokeObjectURL(localFileURL);
          }}
          value={fileValue}
        />
      )}
      {warningMessage && <CMSAssetWarning warningMessage={warningMessage} />}
    </Stack>
  );
};
